const network = process.env.NEXT_PUBLIC_ETH_NETWORK;

if (!network || !network.length) {
  throw new Error(
    'Failed to get network name. Set `NEXT_PUBLIC_ETH_NETWORK` env var.'
  );
}

const subdomain = network === 'Goerli' ? 'goerli.' : '';

export const getEtherscanTransactionLink = (transactionHash: string): string =>
  `https://${subdomain}etherscan.io/tx/${transactionHash}`;

export const getEtherscanAddressLink = (address: string): string =>
  `https://${subdomain}etherscan.io/address/${address}`;
